import React from 'react';
import './Badge.scss';
import { ReactComponent as CheckIcon } from '../../../images/check.svg';
import { ReactComponent as ErrorIcon } from '../../../images/x-close-error.svg';
import { ReactComponent as FailedIcon } from '../../../images/x-close.svg';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default';
  size?: 'sm' | 'md' | 'lg';
  icon?: 'success' | 'error' | 'none' | 'processing' | 'complete' | 'failed';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', size = 'md', icon = 'none', className = '' }) => {
  const renderIcon = () => {
    switch (icon) {
      case 'success':
        return <CheckIcon className='badge__icon' />;
      case 'error':
        return <ErrorIcon className='badge__icon' />;
      case 'processing':
        return <span className='spinner badge__icon' />;
      case 'complete':
        return (
          <span className='badge__complete-icon'>
            <CheckIcon className='badge__icon' />
          </span>
        );
      case 'failed':
        return (
          <span className='badge__failed-icon'>
            <FailedIcon className='badge__icon' />
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`badge badge--${variant} badge--${size} ${icon !== 'none' ? 'badge--with-icon' : ''} ${className}`}>
      {renderIcon()}
      <span className='badge__text'>{children}</span>
    </div>
  );
};

export default Badge;
